import {createRouter, createWebHistory} from 'vue-router'
import Home from '../views/Dashboard/Home.vue'
import Register from '../views/Register.vue'
import Login from '../views/Login.vue'
import Dashboard from "../views/Dashboard.vue";
import PasswordRecover from "../views/Password/PasswordRecover.vue";
import Schedules from "../views/Dashboard/Schedules/Schedules.vue";
import MyAccount from "../views/Dashboard/MyAccount.vue";
import QRCodeScan from "../views/Dashboard/Instances/QRCodeScan.vue";
import Instance from "../views/Dashboard/Instances/Instance.vue";
import Plans from "../views/Plans.vue";
import Subscribe from "../views/Subscribe.vue";
import Install from "../views/Install.vue";
import Payment from "../views/Payment.vue";
import NotFound from "../views/Errors/NotFound.vue";
import New from "../views/Dashboard/Schedules/New.vue";
import Index from "../views/Dashboard/Schedules/Index.vue";
import View from "../views/Dashboard/Schedules/View.vue";
import InstanceChats from "../views/Dashboard/Instances/InstanceChats.vue";
import MessagesComponent from "../components/MessagesComponent.vue";
import WelcomeSubscription from "../views/WelcomeSubscription.vue";
import PendingSubscription from "../views/PendingSubscription.vue";
import SyncConversation from "../views/Dashboard/Instances/SyncConversation.vue";
import DeleteInstance from "../views/Dashboard/Instances/DeleteInstance.vue";
import DeleteSchedule from "../views/Dashboard/Schedules/DeleteSchedule.vue";
import Address from "@/views/Dashboard/Address.vue";
import PasswordReset from "@/views/Password/PasswordReset.vue";
import Unavailable from "@/views/Errors/Unavailable.vue";
import Demonstration from "@/views/Demonstration.vue";

import {setupApiInterceptors} from "@/router/api_interceptors";
import {initMiddlewares} from "@/router/middlewares";
import WApiChats from '@/views/Dashboard/Instances/wApiChats.vue'

const routes = [
    {
        path: '/',
        redirect: {
            name: 'Dashboard'
        }
    },
    {
        path: '/dash',
        redirect: {
            name: 'Dashboard'
        }
    },
    {
        path: '/unavailable',
        name: 'Unavailable',
        component: Unavailable,
        meta: {
            guest: true,
            title: 'unavailable'
        }
    },
    {
        path: '/not-found',
        name: 'NotFound',
        component: NotFound,
        meta: {
            guest: true,
            title: 'not_found'
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            guest: true,
            title: 'login'
        }
    },
    {
        path: '/install',
        name: 'Install',
        component: Install,
        meta: {
            guest: true,
            title: 'installation'
        }
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        meta: {
            guest: true,
            title: 'register'
        }
    },
    {
        path: '/password-recover',
        name: 'PasswordRecover',
        component: PasswordRecover,
        meta: {
            guest: true,
            title: 'password_recovery'
        }
    },
    {
        path: '/password/reset/:token',
        name: 'PasswordReset',
        component: PasswordReset,
        meta: {
            guest: true,
            title: 'password_recovery'
        }
    },
    {
        path: '/demonstration',
        name: 'Demonstration',
        component: Demonstration,
        meta: {
            needsSubscription: false,
            title: 'plans'
        }
    },
    {
        path: '/clients',
        component: Dashboard,
        meta: {
            needsSubscription: true
        },
        children: [
            {
                path: '',
                name: 'Dashboard',
                component: Home,
                meta: {
                    needsSubscription: true,
                    title: 'accounts'
                },
            },
            {
                path: 'schedules',
                component: Schedules,
                meta: {
                    needsSubscription: true
                },
                children: [
                    {
                        path: '',
                        name: 'Schedules',
                        component: Index,
                        meta: {
                            title: 'schedules',
                            needsSubscription: true
                        },
                    },
                    {
                        path: 'new',
                        name: 'NewSchedule',
                        component: New,
                        meta: {
                            title: 'new_schedule',
                            needsSubscription: true
                        },
                    },
                    {
                        path: ':id/view',
                        name: 'ViewSchedule',
                        component: View,
                        props: true,
                        meta: {
                            title: 'view_schedule',
                            needsSubscription: true
                        },
                    },
                    {
                        path: ':id/delete',
                        name: 'DeleteSchedule',
                        component: DeleteSchedule,
                        props: true,
                        meta: {
                            title: 'delete_schedule',
                            needsSubscription: true
                        }
                    }
                ]
            },
            {
                path: 'my-account',
                name: 'MyAccount',
                component: MyAccount,
                meta: {
                    title: 'my_account'
                },
            },
            {
                path: 'qr-code-scan',
                name: 'QRCodeScan',
                component: QRCodeScan,
                meta: {
                    needsSubscription: true,
                    title: 'new_whatsapp_monitor'
                },
            },
            {
                path: 'instances/:id/view',
                name: 'ViewInstance',
                component: Instance,
                props: true,
                meta: {
                    needsSubscription: true,
                    title: 'view_conversations'
                },
                children: [
                    {
                        path: 'wapi',
                        name: 'InstanceWapi',
                        component: WApiChats,
                        props: true,
                        meta: {
                            title: 'view_conversations'
                        }
                    },
                    {
                        path: 'chats',
                        name: 'InstanceChats',
                        component: InstanceChats,
                        props: true,
                        meta: {
                            title: 'view_conversations'
                        }
                    },
                    {
                        path: 'chats/:chat/messages',
                        name: 'InstanceConversation',
                        component: MessagesComponent,
                        props: true,
                        meta: {
                            title: 'view_conversations'
                        }
                    },
                    {
                        path: 'chats/:chat/synchronization',
                        name: 'SyncConversation',
                        component: SyncConversation,
                        props: true,
                        meta: {
                            title: 'sync_conversations'
                        }
                    },
                    {
                        path: 'delete',
                        name: 'DeleteInstance',
                        component: DeleteInstance,
                        props: true,
                        meta: {
                            title: 'delete_instance'
                        }
                    },
                ]
            },
            {
                path: 'subscriptions/plans',
                name: 'Plans',
                component: Plans,
                meta: {
                    needsSubscription: false,
                    needsAuth: true,
                    title: 'plans'
                }
            },
            {
                path: 'subscriptions/:plan/subscribe',
                name: 'Subscribe',
                component: Subscribe,
                props: true,
                meta: {
                    needsSubscription: false,
                    needsAuth: true,
                    title: 'subscribe'
                }
            },
            {
                path: 'subscriptions/:plan/subscribe/:component/:method/payment',
                name: 'Payment',
                component: Payment,
                props: true,
                meta: {
                    needsSubscription: false,
                    needsAuth: true,
                    title: 'payment'
                }
            },
            {
                path: 'subscriptions/welcome/:plan',
                name: 'WelcomeSubscription',
                component: WelcomeSubscription,
                props: true,
                meta: {
                    needsSubscription: true,
                    title: 'welcome_subscription'
                }
            },
            {
                path: 'subscriptions/profile/complete',
                name: 'Address',
                component: Address,
                props: true,
                meta: {
                    needsSubscription: false,
                    needsAuth: true,
                    title: 'complete-information'
                }
            },
            {
                path: 'subscriptions/pending',
                name: 'PendingSubscription',
                component: PendingSubscription,
                meta: {
                    needsSubscription: false,
                    needsAuth: true,
                    title: 'pending_subscription'
                }
            },
            {
                path: '/:pathMatch(.*)*',
                component: NotFound
            }
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        component: NotFound
    }
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL || '/'),
    routes: routes
})

setupApiInterceptors(router);
initMiddlewares(router);

export default router
